module.exports = __webpack_public_path__ + "img/lightning.99059a48.svg";